import React, { useState } from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import Select from "@material-ui/core/Select";
import Input from "./SelectInput";
import Icon from "../Icon";
import { DropDownIconComponent } from "./icons";
import styles, {
  analyzeTemplate,
  select_class_for_menu
} from "./common_styles";
import MenuProps from "./menuProps";
import SearchInput from "../SearchField/components/Inputs/SearchInput";

export const MenuSearchInput = React.memo(
  withStyles(theme => ({
    search_list_item: {
      height: "auto !important",
      textAlign: "center",
      "&:hover, &:focus": {
        background: theme.palette.white
      }
    },
    input: {
      background: theme.palette.white,
      padding: `0 8px`,
      border: `1px solid ${theme.palette.lightGrey}`
    }
  }))(({ classes, input_props, handleChange, search_value }) => {
    return (
      <MenuItem classes={{ root: classes.search_list_item }}>
        <FormControl fullWidth>
          <SearchInput
            onChange={handleChange}
            value={search_value}
            className={`${classes.input} ${input_props.input_class || ""}`}
          />
        </FormControl>
      </MenuItem>
    );
  })
);

const Container = ({
  values,
  menuItem,
  selected,
  selected_value,
  listItemText,
  setBold,
  handleChange
}) => {
  return (
    <div style={{ height: "140px", overflowY: "scroll" }}>
      {values.map(val => (
        <MenuItem
          key={val.id}
          value={val.name}
          classes={{
            root: menuItem,
            selected
          }}
          onClick={() => handleChange(val)}
        >
          <ListItemText
            primary={val.name}
            value={val.name}
            name={val.name}
            aria-label={val.name}
            classes={{
              root: listItemText,
              primary: val.name === selected_value ? setBold : ""
            }}
          />
        </MenuItem>
      ))}
    </div>
  );
};

const SearchSelect = ({
  classes: {
    formControl,
    formControl_with_border,
    colorSecondary,
    checked,
    disabled,
    select,
    setBold,
    root,
    rootOpen,
    menuItem,
    listItemText,
    disable_padding_right,
    selected,
    ...other_classes
  },
  selected_value,
  values,
  handleChange,
  name,
  open,
  handleOpen,
  handleClose,
  icon_component,
  icon_adornment_size,
  select_disabled,
  im_hovered_upon,
  selected_field,
  dropdown_icon,
  dropdown_tooltip_text,
  type,
  input_class,
  className,
  full_width_xs,
  drop_down_menu_button,
  menuProps,
  ...props
}) => {
  const [search_value, handleSearch] = useState(search_value);
  const [filteredValues, handleFilteredValues] = useState(values);

  function handleFilter(e) {
    handleSearch(e.target.value);
    handleFilteredValues(
      values.filter(val =>
        val.name.toUpperCase().includes(e.target.value.toUpperCase())
      )
    );
  }
  return (
    <Select
      value={selected_value}
      onChange={handleChange}
      disabled={select_disabled}
      input={
        <Input
          id="select-native-button"
          className={im_hovered_upon && !drop_down_menu_button ? rootOpen : ""}
          input_class={`
                ${input_class || ""}
              `}
          iconComponent={
            Boolean(icon_component && !(type === "icon")) ? (
              <Icon
                size={icon_adornment_size}
                type={icon_component}
                disabled={select_disabled}
              />
            ) : null
          }
        />
      }
      IconComponent={() => (
        <DropDownIconComponent
          size={type === "icon" ? "md" : "sm"}
          select_disabled={select_disabled}
          dropdown_icon={dropdown_icon}
          dropdown_tooltip_text={dropdown_tooltip_text}
          is_button={drop_down_menu_button}
        />
      )}
      renderValue={selected => analyzeTemplate(selected_field, selected, type)}
      MenuProps={MenuProps({
        paper_class: select_class_for_menu({
          direction: type === "icon" ? "right" : "left",
          fullWidth: full_width_xs,
          classes: other_classes,
          no_adornment: !Boolean(icon_component)
        }),
        direction: type === "icon" ? "right" : "left",
        ...menuProps
      })}
      name={name}
      classes={{
        root,
        select: select + (type === "icon" ? ` ${disable_padding_right}` : "")
      }}
      onClick={e => handleOpen(e, select_disabled)}
      open={open}
      onClose={handleClose}
      onOpen={handleOpen}
      {...props}
    >
      <>
        <div>
          <MenuSearchInput
            input_props={{}}
            handleChange={e => handleFilter(e)}
            search_value={search_value}
          />
        </div>
        <div>
          <Container
            values={filteredValues ? filteredValues : values}
            menuItem={menuItem}
            selected={selected}
            selected_value={selected_value}
            listItemText={listItemText}
            setBold={setBold}
            handleChange={handleChange}
          />
        </div>
      </>
    </Select>
  );
};

SearchSelect.propTypes = {
  classes: PropTypes.shape({
    formControl: PropTypes.string.isRequired,
    formControl_with_border: PropTypes.string.isRequired,
    colorSecondary: PropTypes.string.isRequired,
    checked: PropTypes.string.isRequired,
    disabled: PropTypes.string.isRequired,
    select: PropTypes.string.isRequired,
    setBold: PropTypes.string.isRequired,
    root: PropTypes.string.isRequired,
    rootOpen: PropTypes.string.isRequired,
    selected: PropTypes.string.isRequired
  }),
  selected_value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.array
  ]).isRequired,
  values: PropTypes.array.isRequired,
  handleChange: PropTypes.func,
  name: PropTypes.string,
  open: PropTypes.bool,
  handleOpen: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  icon_component: PropTypes.string,
  icon_adornment_size: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
  select_disabled: PropTypes.bool,
  im_hovered_upon: PropTypes.bool,
  selected_field: PropTypes.string,
  dropdown_icon: PropTypes.string,
  input_class: PropTypes.string,
  full_width_xs: PropTypes.bool,
  drop_down_menu_button: PropTypes.bool
};

SearchSelect.defaultProps = {
  values: [],
  selected_value: "",
  icon_adornment_size: "md",
  selected_field: "selected",
  dropdown_icon: "icon-down-arrow"
};

export default React.memo(withStyles(styles)(SearchSelect));
